import { render, staticRenderFns } from "./CreateOrderPart.vue?vue&type=template&id=1bdf4062&scoped=true&"
import script from "./CreateOrderPart.vue?vue&type=script&lang=js&"
export * from "./CreateOrderPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdf4062",
  null
  
)

export default component.exports